import { render } from "./ChristmasOverlay.vue?vue&type=template&id=2d027405&scoped=true"
import script from "./ChristmasOverlay.vue?vue&type=script&lang=js"
export * from "./ChristmasOverlay.vue?vue&type=script&lang=js"

import "./ChristmasOverlay.vue?vue&type=style&index=0&id=2d027405&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d027405"]])

export default __exports__